"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxInput = void 0;
Object.defineProperty(exports, "CheckBoxInputSize", {
  enumerable: true,
  get: function () {
    return _interface.CheckBoxInputSize;
  }
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireWildcard(require("../Typography/index.js"));
var _CheckBoxComponent = require("./components/CheckBoxComponent.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _StyledCheckMark = _interopRequireDefault(require("./components/StyledCheckMark.js"));
var _interface = require("./interface.js");
var _Grid = _interopRequireDefault(require("../Grid/index.js"));
var _interface2 = require("../Grid/interface.js");
var _ProductConfiguration = require("../../molecules/GroupedFilterContainer/ProductConfiguration.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["name", "value", "label", "caption", "additional", "checked", "hoverColor", "size", "disabled", "labelColor", "captionColor", "defaultColor", "defaultBorderColor", "activeColor", "iconColor", "checkColor", "unCheckedIcon", "inActiveColor", "inActiveBorderColor", "width", "icon", "customContent", "idx", "onCheckedChange", "ref", "opacity", "borderRadius", "labelTypographyVariant", "captionTypographyVariant", "className", "checkboxContainerClassName", "checkBoxDimensions", "defaultBgColor", "hoverBgColor", "tickIconColor", "activeBorderColor", "hoverBorderColor", "defaultBorderWidth", "hoverBorderWidth", "activeBorderWidth", "padding", "margin", "disabledStateBorderColor", "borderStyle", "labelFontFamily", "labelFontStyle", "labelFontWeight", "labelFontSize", "labelTextTransformation", "labelTextDecoration", "labelLetterSpacing", "labelWordSpacing", "captionFontFamily", "captionFontStyle", "captionFontWeight", "captionFontSize", "captionTextTransformation", "captionTextDecoration", "captionLetterSpacing", "captionWordSpacing"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CheckBoxInput = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
      label,
      caption,
      additional,
      checked = true,
      hoverColor = _ProductConfiguration.productConfiguration.bgColor,
      size = _interface.CheckBoxInputSize.medium,
      disabled = false,
      labelColor = theme.color.defaultTextColor,
      captionColor = theme.color.defaultTextColor,
      defaultColor = theme.color.defaultTextColor,
      defaultBorderColor = theme.color.defaultBorderColor,
      activeColor = _ProductConfiguration.productConfiguration.bgColor,
      iconColor = theme.color.primaryBgColor,
      checkColor = theme.color.primaryBgColor,
      unCheckedIcon = '',
      inActiveColor = theme.color.error,
      inActiveBorderColor = theme.color.error,
      icon = 'tick',
      customContent,
      idx,
      onCheckedChange,
      opacity = '1',
      borderRadius = theme.variables.checkBoxLargeBorderRadius,
      labelTypographyVariant = _Typography.typographyVariantEnum.label,
      captionTypographyVariant = _Typography.typographyVariantEnum.caption,
      className = '',
      checkboxContainerClassName = '',
      checkBoxDimensions = '20px',
      defaultBgColor = 'transparent',
      hoverBgColor = 'transparent',
      tickIconColor,
      activeBorderColor = theme.color.primary,
      hoverBorderColor = theme.color.primary,
      defaultBorderWidth = 2,
      hoverBorderWidth = 2,
      activeBorderWidth = 2,
      padding,
      margin,
      disabledStateBorderColor = theme.color.defaultBorderColor,
      borderStyle = 'solid',
      labelFontFamily,
      labelFontStyle,
      labelFontWeight = 400,
      labelFontSize = 12,
      labelTextTransformation,
      labelTextDecoration,
      labelLetterSpacing,
      labelWordSpacing,
      captionFontFamily,
      captionFontStyle,
      captionFontWeight = 400,
      captionFontSize = 14,
      captionTextTransformation,
      captionTextDecoration,
      captionLetterSpacing,
      captionWordSpacing
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const [isHover, setHover] = (0, _react.useState)(false);
  const handleOnChange = () => {
    if (!disabled) onCheckedChange && onCheckedChange(idx, !checked);
  };
  const onMouseEnter = () => {
    if (!disabled) {
      setHover(true);
    }
  };
  const onMouseLeave = () => {
    if (!disabled) {
      setHover(false);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxComponent.StyledCheckBoxComponent, {
    onClick: handleOnChange,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    disabled: disabled,
    className: className,
    padding: padding,
    margin: margin,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      colSpacing: 1,
      spacing: 0,
      alignItems: _interface2.alignItemsEnum.center,
      flexWrap: 'nowrap',
      className: checkboxContainerClassName,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledCheckMark.default, {
          isChecked: checked,
          setIsChecked: handleOnChange,
          color: checkColor,
          bgColor: activeColor,
          borderColor: defaultBorderColor,
          size: size,
          borderRadius: borderRadius,
          isHovered: isHover,
          disabled: !!disabled,
          icon: icon,
          unCheckedIcon: unCheckedIcon,
          inActiveColor: inActiveColor,
          inActiveBorderColor: inActiveBorderColor,
          checkBoxDimensions: checkBoxDimensions,
          defaultBgColor: defaultBgColor,
          hoverBgColor: hoverBgColor,
          tickIconColor: tickIconColor,
          activeBorderColor: activeBorderColor,
          hoverBorderColor: hoverBorderColor,
          defaultBorderWidth: defaultBorderWidth,
          hoverBorderWidth: hoverBorderWidth,
          activeBorderWidth: activeBorderWidth,
          borderStyle: borderStyle,
          disabledStateBorderColor: disabledStateBorderColor
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          container: true,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            xs: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
              container: true,
              spacing: 1,
              children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                xs: "auto",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                  variant: labelTypographyVariant,
                  as: "span",
                  color: labelColor,
                  fontFamily: labelFontFamily,
                  fontStyle: labelFontStyle,
                  fontWeight: `${labelFontWeight}`,
                  fontSize: `${labelFontSize}px`,
                  textTransformation: labelTextTransformation,
                  textDecoration: labelTextDecoration,
                  letterSpacing: `${labelLetterSpacing}px`,
                  wordSpacing: labelWordSpacing,
                  children: label
                })
              }), caption && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                xs: "auto",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                  variant: captionTypographyVariant,
                  as: "span",
                  color: isHover ? hoverColor : captionColor,
                  fontFamily: captionFontFamily,
                  fontStyle: captionFontStyle,
                  fontWeight: `${captionFontWeight}`,
                  fontSize: `${captionFontSize}px`,
                  textTransformation: captionTextTransformation,
                  textDecoration: captionTextDecoration,
                  letterSpacing: `${captionLetterSpacing}px`,
                  wordSpacing: captionWordSpacing,
                  children: caption
                })
              }), customContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                xs: "auto",
                children: customContent
              })]
            })
          }), additional && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            xs: 12,
            children: additional
          })]
        })
      })]
    })
  });
  // return (
  // 	<CheckBoxComponent
  // 		name={name}
  // 		value={value}
  // 		width={width ? width : 'auto'}
  // 		activeColor={activeColor}
  // 		defaultColor={defaultColor}
  // 		opacity={opacity}
  // 		checked={checked}
  // 		hoverColor={hoverColor}
  // 		size={size}
  // 		disabled={disabled}
  // 		iconColor={iconColor}
  // 		icon={icon}
  // 		defaultBorderColor={defaultBorderColor}
  // 		checkColor={checkColor}
  // 		borderRadius={borderRadius}
  // 		theme={theme}
  // 		{...rest}
  // 	>
  // 		<StyledCheckMark
  // 			isChecked={checked}
  // 			setIsChecked={handleOnChange}
  // 			color={checkColor}
  // 			bgColor={activeColor}
  // 			borderColor={defaultBorderColor}
  // 			size={size}
  // 			borderRadius={borderRadius}
  // 			isHovered={isHover}
  // 		/>
  // 		<HorizontalStack width="auto" spacing="16px">
  // 			<input
  // 				ref={ref}
  // 				type="checkbox"
  // 				checked={checked}
  // 				onChange={handleOnChange}
  // 				disabled={disabled}
  // 				name={name}
  // 				value={value}
  // 			/>
  // 			<VerticalStack justifyContent="center">
  // 				{label && (
  // 					<Typography
  // 						variant="button-medium"
  // 						as="span"
  // 						color={isHover ? hoverColor : labelColor}
  // 						onMouseEnter={onMouseEnter}
  // 						onMouseLeave={onMouseLeave}
  // 					>
  // 						{label}
  // 					</Typography>
  // 				)}
  // 				{caption && (
  // 					<Typography variant="caption" as="span" color={captionColor}>
  // 						{caption}
  // 					</Typography>
  // 				)}
  // 				{customContent && customContent}
  // 			</VerticalStack>
  // 			{additional && additional}
  // 		</HorizontalStack>
  // 	</CheckBoxComponent>
  // );
};
exports.CheckBoxInput = CheckBoxInput;
var _default = exports.default = CheckBoxInput;